var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from "react";
// Material Ui
import { FormControl, Select as MuiSelect, Box, MenuItem, InputLabel, } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { menuItemSxProps, selectSxProps, menuSxProps, formControlAsChipSxProps, inputLabelSxPropsFn, } from "./Select.styles";
import ChipV2 from "../../ChipV2";
import Text from "../../Text";
import { getSizeData } from "./constants";
var Select = function (_a) {
    var asChip = _a.asChip, chipProps = _a.chipProps, menuProps = _a.menuProps, optionIcon = _a.optionIcon, onChange = _a.onChange, variant = _a.variant, _b = _a.value, value = _b === void 0 ? "" : _b, children = _a.children, formControlSx = _a.formControlSx, outerLabel = _a.outerLabel, customDisplayValue = _a.customDisplayValue, placeholder = _a.placeholder, name = _a.name, options = _a.options, _c = _a.size, size = _c === void 0 ? "small" : _c, label = _a.label, menuTitle = _a.menuTitle, valueMapping = _a.valueMapping, _d = _a.clearable, clearable = _d === void 0 ? false : _d, sx = _a.sx, rest = __rest(_a, ["asChip", "chipProps", "menuProps", "optionIcon", "onChange", "variant", "value", "children", "formControlSx", "outerLabel", "customDisplayValue", "placeholder", "name", "options", "size", "label", "menuTitle", "valueMapping", "clearable", "sx"]);
    var chipRef = useRef(null);
    var _e = __read(useState(null), 2), anchorEl = _e[0], setAnchorEl = _e[1];
    var _f = __read(React.useState(false), 2), open = _f[0], setOpen = _f[1];
    var anchorSet = Boolean(anchorEl);
    var sizeData = getSizeData(size);
    /**
     * force close menu
     */
    var handleClose = function () {
        if (asChip) {
            setAnchorEl(null);
        }
        setOpen(false);
    };
    // blur chip on close
    useEffect(function () {
        var _a;
        if (!anchorEl) {
            (_a = chipRef === null || chipRef === void 0 ? void 0 : chipRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }, [anchorEl, value]);
    /**
     * open menu
     */
    var handleOpen = function () {
        setOpen(true);
    };
    /**
     * trigger onChange event and force close menu if chip format
     * error in latest material version with onChange type
     */
    var handleChange = function (e, child) {
        var _a;
        if (asChip) {
            handleClose();
        }
        // TBD: REMOVE VALUE CHECK AFTER UPDATING MUI
        if (onChange && typeof ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) !== "undefined") {
            onChange(e, child);
        }
    };
    /**
     * set anchor element for popover positioning to the chip
     */
    var handleChipClick = function (event) {
        if (chipProps === null || chipProps === void 0 ? void 0 : chipProps.onClick) {
            chipProps === null || chipProps === void 0 ? void 0 : chipProps.onClick(event);
        }
        setAnchorEl(event.currentTarget);
    };
    /**
     * set anchor element for popover positioning to the chip (parent of delete icon)
     */
    var handleChipDeleteClick = function (event) {
        if (chipProps === null || chipProps === void 0 ? void 0 : chipProps.onDelete) {
            chipProps === null || chipProps === void 0 ? void 0 : chipProps.onDelete(event);
        }
        if (!value || !clearable) {
            setAnchorEl(event.currentTarget.parentElement);
        }
    };
    /**
     * Determine label to display for selection
     */
    var getDisplayValue = function () {
        if (customDisplayValue) {
            return customDisplayValue;
        }
        if (!value) {
            return chipProps === null || chipProps === void 0 ? void 0 : chipProps.label;
        }
        if (valueMapping === null || valueMapping === void 0 ? void 0 : valueMapping[value]) {
            return valueMapping[value];
        }
        return value.toString();
    };
    /**
     * chip element if used
     */
    var chip = asChip && chipProps ? (_jsx(ChipV2, __assign({}, chipProps, { deleteIcon: !value || !clearable ? chipProps.deleteIcon : undefined, selected: !!value || anchorSet, onClick: handleChipClick, ref: chipRef, onDelete: chipProps.deleteIcon || chipProps.onDelete
            ? handleChipDeleteClick
            : undefined, label: getDisplayValue() }))) : null;
    /**
     * menu props, with some defaults
     */
    var MenuProps = __assign(__assign(__assign({ anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "left",
        } }, (asChip && { open: anchorSet, anchorEl: anchorEl })), { onClose: handleClose, elevation: 2, sx: menuSxProps }), menuProps);
    /**
     * Either parse array of options or render children
     */
    var renderOptions = function () {
        if (children) {
            return children;
        }
        /* istanbul ignore else */
        if (options) {
            return options.map(function (option) { return (_jsxs(MenuItem, __assign({ "data-testid": "menu-item-".concat(option.value), disableRipple: true, value: option.value, sx: menuItemSxProps }, { children: [option.value === value ? (_jsx(CheckIcon, { sx: { mr: 3 } })) : (optionIcon || null), _jsx(Text, __assign({ variant: "body1", ml: option.value === value || optionIcon ? 0 : 9 }, { children: option.label }))] }), option.value)); });
        }
        // unreachable but need as typescript is requiring obove unneeded conditional
        /* istanbul ignore next */
        return null;
    };
    var consolidatedSxProps = __assign(__assign({}, selectSxProps({ sizeData: sizeData })), sx);
    return (_jsxs(Box, __assign({ "data-testid": "selectwrapper-".concat(name) }, { children: [chip, outerLabel && (_jsx(InputLabel, __assign({ htmlFor: "".concat(name, "-select"), sx: { marginBottom: "8px" } }, { children: _jsx(Text, __assign({ variant: "body2" }, { children: outerLabel })) }))), _jsxs(FormControl, __assign({ variant: "outlined", fullWidth: true, sx: __assign(__assign({}, (asChip ? formControlAsChipSxProps : undefined)), formControlSx) }, { children: [label && (_jsx(InputLabel, __assign({ sx: inputLabelSxPropsFn({ sizeData: sizeData }) }, { children: label }))), _jsxs(MuiSelect, __assign({ id: "".concat(name, "-select"), labelId: "".concat(name, "-select-label"), "data-testid": "".concat(name, "-select"), value: value, label: label, MenuProps: MenuProps, open: open, variant: variant, onClose: handleClose, onOpen: handleOpen, onChange: handleChange, sx: consolidatedSxProps, renderValue: function (value) {
                            if (!value && placeholder) {
                                return (_jsx(Text, __assign({ variant: variant === "standard"
                                        ? "subtitle3"
                                        : size === "medium"
                                            ? "body1"
                                            : "body2", emphasis: "disabled" }, { children: placeholder })));
                            }
                            return (_jsx(Text, __assign({ variant: variant === "standard"
                                    ? "subtitle3"
                                    : size === "medium"
                                        ? "body1"
                                        : "body2", emphasis: variant === "standard" ? "medium" : "medium_high" }, { children: getDisplayValue() })));
                        } }, rest, { children: [menuTitle && (_jsx(Text, __assign({ component: "p", sx: { pl: 2, lineHeight: "20px", pt: 2, pb: 2 }, variant: "overline", emphasis: "disabled" }, { children: menuTitle }))), renderOptions()] }))] }))] })));
};
export default Select;
